import React from "react";
import { useState, useEffect } from "react";
import { Card, Col, Row } from "react-bootstrap";
import "../Styling/Home.css";
import PendingTimecardsWordCloud from "../Components/PendingTimecardsWordCloud";
import DailyTimecardsReport from "../Components/DailyTimecardsReport";
import Reports from "./Reports.js/Reports";
import { useAuth } from "../Context/AuthContext";
import PunchInMaster from "./PunchInMaster";
import HrDashboardDropdownDynamic from "./Reports.js/HrDashboard";
import PastAttendance from "./PastAttendance";
import WorkHours from "./WorkHours";
// import PastLeaves from "./PastLeaves";
import UpcomingLeaves from "./UpcomingLeaves";
import Expenses from "./Expenses";
import NewsSection from "./NewsSection";
import TaskSection from "./TaskSection";
import UpcomingHolidays from "./UpcomingHolidays";
import HrDashboard from "./HrDashboard";
import TeamDetails from "./TeamDetails";
import ShimmerDashboard from "./ShimmerDashboard";


  const Home = () => {
  const { user } = useAuth();
  const roles = user?.roles || [];
  const [attendanceUpdated, setAttendanceUpdated] = useState(false);
  const hr = roles.includes("HR");
  const isExecutive =
    roles.includes("Executive") || roles.includes("SD_Employee");
  const [loading, setLoading] = useState(true);    
  const ShimmerOverlay = () => {
      return (
        <div className="shimmer-overlay">
          <ShimmerDashboard />
        </div>
      );
    };
    useEffect(() => {
        // simulate API load
        const timer = setTimeout(() => {
          setLoading(false);
        }, 1500);
        return () => clearTimeout(timer);
      }, []);
  if (hr) {
    return <HrDashboard user={user} />;
  }
  if (isExecutive) {
    return (
      <div className="container-fluid py-4 home-dashboard">
            {loading && <ShimmerOverlay />}
         <div className={`dashboard-content ${loading ? "blur-content" : ""}`}>
        <Row className="g-4 align-items-start">
          {/* LEFT COLUMN */}
          
          <Col xl={4} lg={4} md={6} sm={12}>
            <div className="d-flex flex-column gap-4">
              <PunchInMaster />
              <PastAttendance />
            </div>
          </Col>
          <Col xl={4} lg={4} md={6} sm={12}>
            <div className="d-flex flex-column gap-4">
              <WorkHours />
              <UpcomingHolidays />
              <UpcomingLeaves />
              <Expenses />
            </div>
          </Col>

          {/* RIGHT COLUMN */}
         <Col xl={4} lg={4} md={6} sm={12}>
            <div className="d-flex flex-column gap-4">
              <NewsSection/>
              <TeamDetails />
            </div>
          </Col>
        </Row>
      </div>
      </div>
    );
  }

  return <Reports />;
};

export default Home;
